@if (src(); as url) {
  <div
    class="fixed inset-0 z-[99999] flex items-center justify-center bg-black/80 p-4 backdrop-blur-sm"
    (click)="close.emit()"
  >
    <button
      type="button"
      (click)="close.emit()"
      aria-label="Fermer"
      class="absolute right-4 top-4 flex h-10 w-10 items-center justify-center rounded-full bg-white/10 text-white transition hover:bg-white/20"
    >
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M18 6 6 18M6 6l12 12" stroke-linecap="round" />
      </svg>
    </button>
    <img
      [src]="url"
      [alt]="alt()"
      (click)="$event.stopPropagation()"
      class="max-h-[90vh] max-w-[90vw] rounded-lg object-contain shadow-2xl"
    />
  </div>
}
